//* DEPRECATED, use real time validation instead

const passwordStrength = {
  check(self: Record<string, any>, passwordInput: string, checkMatchInstead = false): void {
    self.weakPasswordError = '';
    const regex = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{6,}/;

    const [icon, color] = (() => {
      const inputEmpty = checkMatchInstead
        ? !self.password.length || !self.confirmPassword.length
        : !self.password.length;
      const passwordOkOnFE = checkMatchInstead
        ? self.password === self.confirmPassword
        : self.password.match(regex);

      if (inputEmpty) return ['', '#707070'];
      return passwordOkOnFE ? ['el-icon-check', '#67C23A'] : ['el-icon-close', '#F56C6C'];
    })();

    checkMatchInstead ? (self.confirmPasswordIcon = icon) : (self.passwordInputIcon = icon);

    setTimeout(() => {
      (document.querySelector(passwordInput).parentNode as HTMLElement).style.color = color;
      (document.querySelector(passwordInput) as HTMLElement).style.borderColor = color;
    });
  },

  notifyAboutWeakPass(self: Record<string, any>, detail: string | string[]): void {
    let errorCopy;

    if (detail.includes('password has been leaked')) errorCopy = self.$t('passwordLeakedInfo');
    if (detail.includes('Password must be six or more'))
      errorCopy = self.$t('passwordStrengthInfo');

    self.weakPasswordError = errorCopy;
  },
};

export default passwordStrength;
